import { useState, useEffect, useContext } from 'react';
import TListing from '../types/TListing';
import getFeedItems from '../apiClient/getFeedItems';
import EnvironmentContext from '../contexts/EnvironmentContext';

// TODO: use shared feedOptions type (to dedupe between this and the TConfig feedOptions)
type TParams = {
  postcode?: string;
  offset?: number;
  limit: number;
  feedType: 'NEARBY' | 'TRENDING' | 'FOR_YOU';
};

const useFetchFeedItems = ({ postcode, offset = 0, limit, feedType }: TParams) => {
  const { xsrfToken } = useContext(EnvironmentContext);
  const [listings, setListings] = useState<TListing[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    setIsError(false);
    setIsEmpty(false);
    setIsLoading(true);
    (async () => {
      try {
        const { feedItems } = await getFeedItems({
          feedOptions: {
            feedType,
            postcode,
            offset,
            limit,
          },
          xsrfToken,
        });

        setListings(feedItems);
        setIsLoading(false);
        setIsError(false);
        setIsEmpty(!feedItems?.length);
      } catch {
        setIsLoading(false);
        setIsError(true);
      }
    })();
  }, [feedType, limit, offset, postcode, xsrfToken]);

  return { listings, isLoading, isError, isEmpty };
};

export default useFetchFeedItems;
